export enum MapsSearchInputMode {
  PLACE = 'PLACE',
  ADDRESS = 'ADDRESS',
  REGION = 'REGION',
}
